import React, {useMemo, useRef, useState} from 'react'
import styled from 'styled-components'
import {MapRef, Marker} from 'react-map-gl/maplibre'
import {ViewportState} from 'types'
import {useDidUpdate} from 'utils'
import convertUnit from 'lib/unit'
import {Map, Pin} from 'common/components'

export interface TreePlantSelectedLocationProps {
  latitude: number
  longitude: number
}

const StyledMapContainer = styled.div`
  height: ${convertUnit(74)};
  border-radius: ${convertUnit(8)};
  margin-bottom: ${convertUnit(8)};
  width: 100%;
  overflow: hidden;
`

export default function TreePlantSelectedLocation({
  latitude,
  longitude,
}: TreePlantSelectedLocationProps) {
  const mapRef = useRef<MapRef>(null)
  const mapAttributeState = useState<ViewportState>({
    latitude,
    longitude,
    zoom: 15,
  })

  useDidUpdate(() => {
    mapRef.current?.jumpTo({
      center: [longitude, latitude],
      zoom: 15,
    })
  }, [longitude, latitude])

  const renderMap = useMemo(
    () =>
      latitude && longitude ? (
        <Map
          mapRef={mapRef}
          viewportState={mapAttributeState}
          dragPan={false}
          dragRotate={false}>
          <Marker longitude={longitude} latitude={latitude}>
            <Pin />
          </Marker>
        </Map>
      ) : null,
    [latitude, longitude, mapAttributeState],
  )

  return <StyledMapContainer>{renderMap}</StyledMapContainer>
}
